import { render, staticRenderFns } from "./UsersDetailRow.vue?vue&type=template&id=ac8278a8&"
import script from "./UsersDetailRow.vue?vue&type=script&lang=js&"
export * from "./UsersDetailRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports